import React from "react";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import { formatDateTimeWithTz } from "../../../../../../utils/formatDateTimeWithTz";
import { formatValidityPeriod } from "../../../../../../utils/formatValidity";
import InfoBlock from "../../../../../common/InfoBlock";
import ContactWithTracking from "../ContactWithTracking";
import { LogRenderContext } from "../LogRenderer";
import { commonConfig, fillMissingValidityWithOldValues } from "../utils";
// Campaign Details Panel Component
const CampaignDetailsPanel = () => {
  const { log, userTimeZone } = React.useContext(LogRenderContext);
  const campaign = log.dataSnapshot?.campaign;
  const campaignNew = log.changedFields?.campaign || {};
  const contacts = campaign?.contacts || [];
  const contactsNew = campaignNew?.contacts || [];
  const billingInfo = campaign?.billingInfo || {};
  const billingInfoNew = campaignNew?.billingInfo || {};
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <InfoBlock
        header={"Campaign Details"}
        className={styles.changeTracking}
        config={commonConfig([
          {
            title: "Campaign Name",
            value: { old: campaign?.name, new: campaignNew?.name },
          },
          {
            title: "Client",
            value: {
              old: campaign?.advertiserName,
              new: campaignNew?.advertiserName,
            },
          },
          {
            title: "Validity",
            value: {
              old: formatValidityPeriod(campaign?.validity),
              new: formatValidityPeriod(
                fillMissingValidityWithOldValues(campaign?.validity, campaignNew?.validity)
              ),
            },
          },
          {
            title: "Created On",
            value: {
              old: campaign?.createdAt
                ? formatDateTimeWithTz(campaign?.createdAt, userTimeZone)
                : undefined,
              new: campaignNew?.createdAt
                ? formatDateTimeWithTz(campaignNew?.createdAt, userTimeZone)
                : undefined,
            },
          },
          {
            title: "Currency",
            value: { old: campaign?.currencyName, new: campaignNew?.currencyName },
          },
          {
            title: "Country",
            value: {
              old: campaign?.countries?.map((country) => country.name).join(", "),
              new: campaignNew?.countries?.map((country) => country.name).join(", "),
            },
          },
          {
            title: "Campaign Value",
            value: {
              old: campaign?.campaignValue,
              new: campaignNew?.campaignValue,
            },
          },
          {
            title: "Effective Rate",
            value: {
              old: campaign?.effectiveRate
                ? (() => {
                    const er = campaign.effectiveRate.toString().split(".");
                    if (!er[1]) return campaign.effectiveRate;
                    er[1] = er[1].slice(0, 2);
                    return er.join(".");
                  })()
                : undefined,
              new: campaignNew?.effectiveRate
                ? (() => {
                    const er = campaignNew.effectiveRate.toString().split(".");
                    if (!er[1]) return campaignNew.effectiveRate;
                    er[1] = er[1].slice(0, 2);
                    return er.join(".");
                  })()
                : undefined,
            },
          },
        ])}
      />
      {
        <div className={styles.contactContainer}>
          {contacts.length === 0
            ? contactsNew.map((contactNew, index) => {
                const contactWithChanges = {
                  name: { old: undefined, new: contactNew?.name },
                  type: { old: undefined, new: contactNew?.type },
                  phone: { old: undefined, new: contactNew?.phoneNumber },
                  email: { old: undefined, new: contactNew?.email },
                };
                return <ContactWithTracking key={index} {...contactWithChanges} />;
              })
            : contacts.map((contact, index) => {
                const [contactNew] = contactsNew.filter((c) => c.id === contact.id);
                const contactWithChanges = {
                  name: { old: contact?.name, new: contactNew?.name },
                  type: { old: contact?.type, new: contactNew?.type },
                  phone: { old: contact?.phoneNumber, new: contactNew?.phoneNumber },
                  email: { old: contact?.email, new: contactNew?.email },
                };
                return <ContactWithTracking key={index} {...contactWithChanges} />;
              })}
        </div>
      }
      <InfoBlock
        header={"Billing Details"}
        className={styles.changeTracking}
        config={commonConfig([
          {
            title: "Biller Name",
            value: { old: billingInfo?.billerName, new: billingInfoNew?.billerName },
          },
          {
            title: "Billing Address",
            value: {
              old: billingInfo?.billingAddress,
              new: billingInfoNew?.billingAddress,
            },
          },
          {
            title: "Billing Cycle",
            value: {
              old: billingInfo?.billingCycleName,
              new: billingInfoNew?.billingCycleName,
            },
          },
          {
            title: "Payment Term",
            value: {
              old: billingInfo?.paymentTermInDays
                ? `${billingInfo.paymentTermInDays} Days`
                : billingInfo?.paymentTermInDays,
              new: billingInfoNew?.paymentTermInDays
                ? `${billingInfoNew.paymentTermInDays} Days`
                : billingInfoNew?.paymentTermInDays,
            },
          },
          {
            title: "Advance Amount",
            value: {
              old: billingInfo?.isAdvanceAmountRequired ? billingInfo?.advanceAmount : undefined,
              new: billingInfoNew?.isAdvanceAmountRequired
                ? billingInfoNew?.advanceAmount
                : undefined,
            },
          },
          {
            title: "Order Region",
            value: {
              old: billingInfo?.orderRegionName,
              new: billingInfoNew?.orderRegionName,
            },
          },
          {
            title: "Purchase Order ID",
            value: {
              old: billingInfo?.orderId,
              new: billingInfoNew?.orderId,
            },
          },
        ])}
      />
    </div>
  );
};

export default CampaignDetailsPanel;
